import { type Routes } from '@angular/router';
import { EFilingComponent } from './components/e-filing/e-filing.component';
import { QuoteLogComponent } from './components/quote-log/quote-log.component';
import { ReportingComponent } from './components/reporting/reporting.component';
import { PartCodingComponent } from './components/part-coding/part-coding.component';
import { NoAccessComponent } from './components/no-access/no-access.component';
import { MsalGuard, MsalRedirectComponent } from '@azure/msal-angular';
import { quoteLogGuard } from './guards/quote-log.guard';
import { eFilingGuard } from './guards/e-filing.guard';
import { homeRedirectGuard } from './guards/home-redirect.guard';
import { reportingGuard } from './guards/reporting.guard';
import { partCodingGuard } from './guards/part-coding.guard';
import { PartCodingAdminComponent } from './components/part-coding-admin/part-coding-admin.component';
import { partCodingAdminGuard } from './guards/part-coding-admin.guard';
import { SoGapComponent } from './components/so-gap/so-gap.component';
import { soGapGuard } from './guards/so-gap.guard';

export const routes: Routes = [
	{
		path: '',
		pathMatch: 'full',
		canActivate: [MsalGuard, homeRedirectGuard],
		children: []
	},
	{
		path: 'e-filing',
		component: EFilingComponent,
		canActivate: [MsalGuard, eFilingGuard]
	},
	{
		path: 'quote-log',
		component: QuoteLogComponent,
		canActivate: [MsalGuard, quoteLogGuard]
	},
	{
		path: 'reporting',
		component: ReportingComponent,
		canActivate: [MsalGuard, reportingGuard]
	},
	{
		path: 'part-coding',
		component: PartCodingComponent,
		canActivate: [MsalGuard, partCodingGuard]
	},
	{
		path: 'part-coding-admin',
		component: PartCodingAdminComponent,
		canActivate: [MsalGuard, partCodingAdminGuard]
	},
	{
		path: 'so-gap',
		component: SoGapComponent,
		canActivate: [MsalGuard, soGapGuard]
	},
	{
		path: 'no-access',
		component: NoAccessComponent,
		canActivate: [MsalGuard]
	},
	{ path: 'login/callback', component: MsalRedirectComponent }
];
